import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PlatformPrivateEvent } from '@wix/public-editor-platform-events';
import { EventType } from '@wix/editor-platform-sdk-types';
import { ApplicationType } from '@wix/editor-application';
import { ApplicationSpecExtractorComposite } from './getAppSpecsFromCSM';
import { AddonsExtractor } from './getAppSpecsFromCSM/AddonsExtractor';
export class AppRunner {
  constructor(ps, manager) {
    this.ps = ps;
    this.manager = manager;
    _defineProperty(this, "events", void 0);
    _defineProperty(this, "applicationSpecExtractor", new ApplicationSpecExtractorComposite(this.ps).with(new AddonsExtractor()));
    this.ps = ps;
    this.manager = manager;
    this.events = manager.events;
  }
  async registerToolPanel(appSpec, shouldOpenPanel) {
    var _appSpec$data, _appSpec$data2;
    const {
      url,
      width,
      height,
      initialPosition
    } = ((_appSpec$data = appSpec.data) == null ? void 0 : _appSpec$data.toolPanelConfig) || {};
    if (!url) {
      throw new Error('Tool panel URL is required');
    }

    // TODO: handle errors
    const openPanel = await this.ps.hostAPI.editor.registerToolsPanel(
    // @ts-expect-error
    {
      appDefinitionId: appSpec.appDefinitionId
    }, {
      title: (appSpec == null || (_appSpec$data2 = appSpec.data) == null || (_appSpec$data2 = _appSpec$data2.marketData) == null ? void 0 : _appSpec$data2.name) || appSpec.appDefinitionName
    }, {
      url,
      // TODO: this can become "200px", "50%" etc in future. For now we simply assume numeric values like "250".
      width: Number(width),
      height: Number(height),
      initialPosition: {
        x: Number(initialPosition == null ? void 0 : initialPosition.x),
        y: Number(initialPosition == null ? void 0 : initialPosition.y)
      }
    });
    if (shouldOpenPanel) {
      openPanel();
    }
  }
  async runApplication(appSpec, appRunParams) {
    if (appRunParams === void 0) {
      appRunParams = {
        firstInstall: false
      };
    }
    try {
      await this.events.withEvent(this.events.factories.createRunApplicationEvent(appSpec), async () => {
        if (appSpec.type === ApplicationType.EditorAddon) {
          this.registerToolPanel(appSpec, appRunParams.firstInstall);
        }
        if (appSpec.url) {
          const workerAPI = await this.manager.getWorkerAPI();
          await workerAPI.runApplication(appSpec);
        }
      });
    } catch (e) {
      console.error('runApplication', e);
      throw e;
    }
  }
  async run(apps, appRunParams) {
    return Promise.allSettled(apps.map(app => this.runApplication.call(this, app, appRunParams)));
  }
  async runInstalledApp(event) {
    var _event$payload;
    if (event.type === PlatformPrivateEvent.HostEvent && ((_event$payload = event.payload) == null ? void 0 : _event$payload.type) === EventType.appInstalled) {
      const apps = this.applicationSpecExtractor.execute().filter(app => {
        return app.appDefinitionId === event.meta.appDefinitionId;
      });
      await this.run(apps, {
        firstInstall: true
      });
    }
  }
  handleAppEvents() {
    this.events.subscribe(async event => {
      await this.runInstalledApp(event);
    });
  }
  async runAppsFromCSM() {
    const apps = this.applicationSpecExtractor.execute();
    if (apps.length === 0) {
      return;
    }
    this.manager.events.notify({
      type: PlatformPrivateEvent.ApplicationsSpecsReceived,
      payload: {
        appDefinitionIds: apps.map(app => app.appDefinitionId)
      },
      meta: {}
    });
    await this.run(apps);
  }
  async start() {
    await this.runAppsFromCSM();
    this.handleAppEvents();
  }
}
//# sourceMappingURL=AppRunner.js.map